import { MoveDownRight, MoveUpRight } from 'lucide-react';
import {
    TopPostInstagramThumbnail,
    TopPostTikTokThumbnail,
} from 'components/Post/Post';
import { Badge } from '@/ui/design-system/components/ui/badge';
import Badges from 'components/Post/Badges';
import { cn } from '@/ui/design-system/utils/cn';
import { formatAbsoluteGrowth } from 'utils/helpers';

function DrawerPostComponent({
    post,
    sortOption,
    visibleOrderedMetrics,
    dataSource = 'tiktok',
    changeLabel = 'Increase WoW',
    periodRatioLabel = 'WoW',
}) {
    const normalizedDataSource = String(dataSource || 'tiktok').toLowerCase();
    const isInstagram =
        normalizedDataSource === 'instagram' ||
        normalizedDataSource === 'pop_index_instagram';
    const ThumbnailComponent = isInstagram
        ? TopPostInstagramThumbnail
        : TopPostTikTokThumbnail;
    const increaseKey = sortOption?.sortBy || 'non_cum_increase_WoW';
    const increaseValue = post[increaseKey] ?? post.non_cum_increase_WoW;
    const isPositive = (increaseValue ?? 0) >= 0;
    const formattedValue = formatAbsoluteGrowth(increaseValue);
    return (
        <div className="flex flex-col gap-3">
            <div className="flex flex-col gap-2">
                <ThumbnailComponent
                    url={post.url}
                    key={`${sortOption.sortBy}-${post.url}`}
                />
                <Badges post={post} />
            </div>
            {visibleOrderedMetrics.length > 0 && (
                <div className="flex flex-col gap-2 mt-auto">
                    {visibleOrderedMetrics.map(
                        ({ key, tableHeadColumnLabel, format }) => (
                            <div
                                key={key}
                                className="flex items-center justify-between text-xs text-muted-foreground min-h-[1.375rem]"
                            >
                                <span>
                                    {key === 'non_cum_increase_WoW' ||
                                    key === 'non_cum_increase_MoM'
                                        ? changeLabel
                                        : key === 'non_cum_WoW' ||
                                            key === 'non_cum_MoM'
                                          ? periodRatioLabel
                                          : key === 'last_week_views'
                                            ? 'Views'
                                            : key === 'last_week_likes'
                                              ? 'Likes'
                                              : tableHeadColumnLabel}
                                </span>
                                {key === increaseKey ||
                                (key === 'non_cum_increase_WoW' &&
                                    increaseKey === 'non_cum_increase_MoM') ? (
                                    <Badge
                                        className={`self-start border-transparent ${
                                            isPositive
                                                ? 'bg-green-100 text-foreground'
                                                : 'bg-red-50 text-foreground'
                                        }`}
                                    >
                                        <span className="uppercase">
                                            {formattedValue}
                                        </span>
                                        {isPositive ? (
                                            <MoveUpRight className="size-3 text-green-600" />
                                        ) : (
                                            <MoveDownRight className="size-3 text-red-600" />
                                        )}
                                    </Badge>
                                ) : (
                                    <span
                                        className={cn(
                                            'text-foreground font-medium',
                                            key !== 'create_timestamp'
                                                ? 'uppercase'
                                                : '',
                                        )}
                                    >
                                        {format(post[key])}
                                    </span>
                                )}
                            </div>
                        ),
                    )}
                </div>
            )}
        </div>
    );
}

export default DrawerPostComponent;
